import React, { useEffect, useState } from 'react';
import {
  ConfigProvider,
  Layout,
  Menu,
  Skeleton,
  Space,
  Typography
} from 'antd';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';

import './App.css';
import LoginForm from './components/LoginForm';
import Console from './components/Console';
import Authorize from './components/Authorize';
import MyApps from './components/MyApps';
import AdminMyApps from './components/AdminMyApps';
import UsersAPI from './api/user';
import AuthAPI from './api/auth';
import Cookies from 'universal-cookie';
import TicketsAPI from './api/ticket';


const { Title } = Typography;

const SYS_ADMIN_BIT = 8;

function isAdmin(user) {
  return !!(user && (Number(user.sys_roles) & SYS_ADMIN_BIT));
}

function App() {

  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    if (!user) {
      return;
    }
    TicketsAPI.search({},
      (res) => {
        setSessions(res);
      },
      (err) => {
        console.log(err);
      }
    )
    return () => {

    }
  }, [user]);


  const cookies = new Cookies();

  let service = null;
  try {
    const st_requestService = window.atob(cookies.get('SSO_requestService'));
    console.log('requestService', st_requestService);
    service = JSON.parse(st_requestService);
  } catch (e) {
    console.log(e);
  }

  const logout = () => {
    AuthAPI.logout(
      (res) => {
        setUser(null);
      },
      (err) => {
        console.log(err);
      });
  }

  const onLogin = () => {
    setIsLoading(true);
    UsersAPI.me(
      (user) => {
        setUser(user);
        setIsLoading(false);
      },
      (err) => {
        setUser(null);
        setIsLoading(false);
      })
  }

  useEffect(() => {
    onLogin();
    return () => {

    }
  }, []);


  const homeContent = <>
    {!user && <LoginForm onLogin={onLogin} />}
    {user && <>
      {service && <Authorize user={user} service={service} />}
      <Console sessions={sessions} user={user} onLogout={logout} />
    </>}
  </>;

  const gate = (node) => {
    if (!user) return <LoginForm onLogin={onLogin} />;
    return node;
  };

  return (
    <ConfigProvider theme={{ token: { colorPrimary: '#fc46aa' } }}>
      <BrowserRouter basename="/html">
        <Layout style={{ minHeight: '100vh' }}>
          <AppHeader user={user} service={service} />
          <Layout.Content style={{ padding: '5px' }}>
            <Skeleton loading={isLoading} avatar>
              <Routes>
                <Route path="/" element={homeContent} />
                <Route path="/myapps" element={gate(<MyApps user={user} />)} />
                <Route
                  path="/admin/myapps"
                  element={
                    user
                      ? (isAdmin(user) ? <AdminMyApps user={user} /> : <Navigate to="/" replace />)
                      : <LoginForm onLogin={onLogin} />
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Skeleton>
          </Layout.Content>
          <Layout.Footer>
            <address>A solution by Krerk Piromsopa, Ph.D.<br /> for Chulalongkorn University.</address>
            For more information, visit our <a href="/wiki/">wiki</a> page.
          </Layout.Footer>
        </Layout>
      </BrowserRouter>
    </ConfigProvider>
  );
}

function AppHeader({ user, service }) {
  const location = useLocation();
  const navigate = useNavigate();
  const showNav = !!user && !service;

  const items = [{ key: '/', label: 'Home' }, { key: '/myapps', label: 'My Apps' }];
  if (isAdmin(user)) {
    items.push({ key: '/admin/myapps', label: 'Admin — App Requests' });
  }

  return (
    <Layout.Header style={{
      height: 80,
      alignItems: 'center',
      backgroundColor: 'pink',
      paddingTop: '0',
      paddingBottom: '0',
      display: 'flex',
      justifyContent: 'space-between',
    }}>
      <Space>
        <img src="/html/logo-chula-color.svg" width={100} alt="Chula" style={{ verticalAlign: 'middle' }} />
        <Title level={2} style={{ margin: 0 }}>SSO 2.0</Title>
      </Space>
      {showNav && (
        <Menu
          mode="horizontal"
          selectedKeys={[location.pathname]}
          onClick={({ key }) => navigate(key)}
          items={items}
          style={{ backgroundColor: 'transparent', borderBottom: 'none', minWidth: 400, justifyContent: 'flex-end' }}
        />
      )}
    </Layout.Header>
  );
}

export default App;
